import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/style.css'
import Cookies from 'js-cookie'
import VueClipboard from 'vue-clipboard2'
import seoPlugin from './plugins/seoPlugin'
// 引入 Message 插件
import MessagePlugin from './plugins/messagePlugin'
import { updatePageMeta } from './utils/seoMeta'
import { getToken, setToken, setStore, syncLoginStatus } from '@/utils/auth'
import VueMeta from 'vue-meta'
import './plugins/element.js'
// 设置 store 实例到 auth 模块
setStore(store)

const token = getToken()
if (token) {
  setToken(token) // 这会确保两个地方都有 token
}

// 同步登录状态
syncLoginStatus()

// 引入axios配置
import request from './utils/request'

Vue.config.productionTip = false;
Vue.use(VueMeta)
Vue.use(VueClipboard)
// 注册 SEO 插件
Vue.use(seoPlugin)
// 注册 Message 插件
Vue.use(MessagePlugin)

Vue.prototype.$Cookies = Cookies

// 全局挂载axios
Vue.prototype.$http = request
Vue.prototype.$store = store

// 监听 Vuex 中 language 的变化
store.subscribe((mutation, state) => {
  if (mutation.type === 'changeLanguage') {
    // 当语言改变时，更新页面元数据
    updatePageMeta(state.language);
  }
});

// 创建 Vue 实例
const app = new Vue({
  router,
  store,
  render: (h) => h(App),
});

// 挂载应用
app.$mount('#app');

// 应用挂载后立即更新元数据
Vue.nextTick(() => {
  const currentLanguage = store.state.language || 'zh';
  updatePageMeta(currentLanguage);
});